module.exports = __webpack_public_path__ + "assets/img/driver-btn-79a5faa0.png";